export function formatNumberWithCommas(value: number | string): string {
  let numberValue: number;

  if (typeof value === "string") {
    numberValue = parseFloat(value.replace(/,/g, ""));
    if (isNaN(numberValue)) {
      console.error(`Invalid input: ${value} is not a valid number.`);
      return "";
    }
  } else {
    numberValue = value;
  }

  const formatter = new Intl.NumberFormat("en-US");
  return formatter.format(numberValue);
}

export function toDecimalString(value: number): string {
  return value.toLocaleString("en-US");
}

export function isHiraganaOnly(text: string) {
  if (text.length === 0) {
    return false;
  }
  const trimmedText = text.trim();
  return /^[\u3040-\u309F]+$/.test(trimmedText);
}

export function sanitizeStringAndNormalize(input: string): string {
  let sanitized = input.replace(/\(.*?\)/g, "");
  sanitized = sanitized.replace(/\{.*?\}/g, "");
  sanitized = sanitized.replace(/\[.*?\]/g, "");
  sanitized = sanitized.replace(/[^\p{L}\p{N}]/gu, ""); // `u` 플래그로 유니코드 지원
  return sanitized.toLowerCase();
}

export function sanitizeAndSplitStringAndNormalize(input: string): string[] {
  let sanitized = input.toLowerCase().replace(/\(.*?\)/g, "");
  sanitized = sanitized.replace(/\{.*?\}/g, "");
  sanitized = sanitized.replace(/\[.*?\]/g, "");

  const parts = sanitized
    .split(/[,;]/)
    .map((s) => s.trim())
    .filter((s) => s.length > 0);

  const posRemovedParts = parts.map((part) =>
    part.replace(/\b(?:v\.|a\.|n\.|ad\.|prep\.|adj\.)\s*/g, "")
  );
  const sanitizedParts = posRemovedParts.map(
    (part) => part.replace(/[^\p{L}\p{N}]/gu, "") // `u` 플래그로 유니코드 지원
  );
  return sanitizedParts;
}

export function normalizeString(str: string): string {
  return str
    .toLowerCase() // 소문자로 변환
    .replace(/\s+/g, ""); // 모든 공백 제거
}
